import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import lesson0202 from "../../../lesson/course-02/lesson-02/lesson";
import lesson0203 from "../../../lesson/course-02/lesson-03/lesson";
import lesson0214 from "../../../lesson/course-02/lesson-14/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "8f9d5d18-80fb-4058-bf8e-78c649569417",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0202),
    lesson: lesson0202,
  },
  {
    id: "183cbf03-6106-4429-b852-d814970584d4",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0203),
    lesson: lesson0203,
  },
  {
    id: "856c0897-f2a7-4974-a85c-660d5f484c5a",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0214),
    lesson: lesson0214,
  },
];

export default lessonLinks;
